<template>
  <div class="behavioral-interest">
    <p class="level-2">
      行为兴趣意向
      <el-popover placement="top" trigger="hover">
        <p style="font-size: 12px">将定向到符合所选行为或兴趣的用户</p>
        <i class="el-icon-question" slot="reference"></i>
      </el-popover>
    </p>
    <el-radio-group v-model="form.audience.interest" size="medium">
      <el-radio-button label="不限"></el-radio-button>
      <el-radio-button label="系统推荐"></el-radio-button>
      <el-radio-button label="自定义"></el-radio-button>
    </el-radio-group>

    <div class="box" v-show="form.audience.interest == '自定义'">
      <div class="behavior">
        <p class="title">
          行为
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              行为将根据用户近期在电商、资讯、App推广场景中的互动行为(阅读、搜索、观看等)匹配用户
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <div class="select-title">
          在
          <el-select
            v-model="form.audience.behavioralInterest.scene"
            multiple
            collapse-tags
            size="small"
            placeholder="所有行为场景"
            style="width: 220px"
          >
            <el-option label="电商互动行为" value="电商互动行为"> </el-option>
            <el-option label="资讯互动行为" value="资讯互动行为"> </el-option
            ><el-option label="App推广互动行为" value="App推广互动行为">
            </el-option
          ></el-select>
          中，选择用户
          <el-select
            v-model="form.audience.behavioralInterest.day"
            size="small"
            placeholder="请选择"
            style="width: 90px"
          >
            <el-option label="7天" value="7天"> </el-option>
            <el-option label="15天" value="15天"> </el-option>
            <el-option label="30天" value="30天"> </el-option>
            <el-option label="60天" value="60天"> </el-option>
            <el-option label="90天" value="90天"> </el-option>
            <el-option label="180天" value="180天"> </el-option>
            <el-option label="365天" value="365天"> </el-option>
          </el-select>
          内发生的行为：
        </div>
        <div class="search">
          <el-input
            size="small"
            placeholder="请输入行为类目词或关键词"
            prefix-icon="el-icon-search"
            style="width: 424px"
            v-model="searchWord"
          >
          </el-input>
        </div>
        <div class="action-inerest-form">
          <div class="left-form">
            <div class="form-title">
              <div class="tab active">类目词</div>
              <div class="tab disabled">关键词词</div>
            </div>
            <div class="s-head">行为类目词</div>
            <div class="select-form">
              <el-cascader-panel
                ref="cascader"
                v-model="form.audience.behavioralInterest.behaviorArr"
                :border="false"
                :options="options"
                :props="{
                  multiple: true,
                  emitPath: false,
                  value: 'label',
                }"
              ></el-cascader-panel>
            </div>
            <div class="correlation-word">
              <p>关键词推荐：</p>
              <p>选择类目词后,根据相关性推荐关键词</p>
            </div>
          </div>
          <div class="right-form">
            <div class="form-title">
              <p class="added-behavoirs">
                已添加行为
                <span>{{
                  form.audience.behavioralInterest.behaviorArr.length
                }}</span>
                / 349
              </p>
              <p class="word-num">
                <span
                  >类目词：{{
                    form.audience.behavioralInterest.behaviorArr.length
                  }}</span
                >
                <span>关键词：0</span>
              </p>
              <span
                class="clear-btn"
                @click="$refs.cascader.clearCheckedNodes()"
                >清空</span
              >
            </div>
            <div class="s-head">
              <span class="all">全部</span>
              <span>覆盖人数</span>
            </div>
            <div class="body">
              <template
                v-if="form.audience.behavioralInterest.behaviorArr.length > 0"
              >
                <div
                  class="list-item"
                  v-for="(item, idx) in form.audience.behavioralInterest
                    .behaviorArr"
                  :key="idx"
                >
                  <span class="name ellipsis">{{ item }}</span>
                  <span class="num ellipsis">160万</span>

                  <span class="icons">
                    <i class="el-icon-search"></i>
                    <i
                      class="el-icon-delete"
                      @click="handleDelItem('behaviorArr', item)"
                    ></i>
                  </span>
                </div>
              </template>
              <div class="empty" v-else>
                <el-image
                  class="img"
                  :src="require(`@/assets/images/simulation/icon_noWord.png`)"
                  fit="cover"
                ></el-image>
                <p>未添加行为</p>
              </div>
            </div>
            <div class="auto-select-word">
              <span>使用自动选词</span>
              <el-popover placement="top" trigger="hover">
                <p style="font-size: 12px">
                  系统根据行为定向所有已选结果,自动推荐词包
                </p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="interest">
        <p class="title">
          兴趣
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              兴趣将根据用户可能存在的兴趣寻找潜在的转化人群
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <div class="search">
          <el-input
            size="small"
            placeholder="请输入行为类目词或关键词"
            prefix-icon="el-icon-search"
            style="width: 424px"
            v-model="searchWord"
          >
          </el-input>
        </div>
        <div class="action-inerest-form">
          <div class="left-form">
            <div class="form-title">
              <div class="tab active">类目词</div>
              <div class="tab disabled">关键词词</div>
            </div>
            <div class="s-head">兴趣类目词</div>
            <div class="select-form">
              <el-cascader-panel
                ref="xqCascader"
                v-model="form.audience.behavioralInterest.interestArr"
                :border="false"
                :options="options"
                :props="{
                  multiple: true,
                  emitPath: false,
                  value: 'label',
                }"
              ></el-cascader-panel>
            </div>
            <div class="correlation-word">
              <p>关键词推荐：</p>
              <p>选择类目词后,根据相关性推荐关键词</p>
            </div>
          </div>
          <div class="right-form">
            <div class="form-title">
              <p class="added-behavoirs">
                已添加兴趣
                <span>{{
                  form.audience.behavioralInterest.interestArr.length
                }}</span>
                / 349
              </p>
              <p class="word-num">
                <span
                  >类目词：{{
                    form.audience.behavioralInterest.interestArr.length
                  }}</span
                >
                <span>关键词：0</span>
              </p>
              <span
                class="clear-btn"
                @click="$refs.xqCascader.clearCheckedNodes()"
                >清空</span
              >
            </div>
            <div class="s-head">
              <span class="all">全部</span>
              <span>覆盖人数</span>
            </div>
            <div class="body">
              <template
                v-if="form.audience.behavioralInterest.interestArr.length > 0"
              >
                <div
                  class="list-item"
                  v-for="(item, idx) in form.audience.behavioralInterest
                    .interestArr"
                  :key="idx"
                >
                  <span class="name ellipsis">{{ item }}</span>
                  <span class="num ellipsis">160万</span>

                  <span class="icons">
                    <i class="el-icon-search"></i>
                    <i
                      class="el-icon-delete"
                      @click="handleDelItem('interestArr', item)"
                    ></i>
                  </span>
                </div>
              </template>
              <div class="empty" v-else>
                <el-image
                  class="img"
                  :src="require(`@/assets/images/simulation/icon_noWord.png`)"
                  fit="cover"
                ></el-image>
                <p>未添加兴趣</p>
              </div>
            </div>
            <div class="auto-select-word">
              <span>使用自动选词</span>
              <el-popover placement="top" trigger="hover">
                <p style="font-size: 12px">
                  系统根据行为定向所有已选结果,自动推荐词包
                </p>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import category from "@/utils/category.js";
export default {
  props: {
    form: Object,
  },
  data() {
    return {
      searchWord: "",
      options: category.options,
    };
  },
  methods: {
    handleDelItem(str, word) {
      let newArr = this.form.audience.behavioralInterest[str].filter((item) => {
        return item != word;
      });
      this.form.audience.behavioralInterest[str] = newArr;
    },
  },
};
</script>

<style lang="less" scoped>
.behavioral-interest {
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
  .box {
    padding: 16px;
    margin-top: 14px;
    width: 750px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    .behavior,
    .interest {
      .title {
        margin-bottom: 16px;
        font-weight: 600;
        font-size: 14px;
        height: 22px;
        line-height: 22px;
      }
      &.interest {
        margin-top: 20px;
      }
      ::v-deep .el-select,
      ::v-deep .el-input {
        .el-input__inner {
          background-color: #f2f2f2;
        }
        .el-tag.el-tag--info {
          background-color: #fff;
        }
      }
      .search {
        margin-top: 16px;
        margin-bottom: 12px;
      }
      .action-inerest-form {
        overflow: hidden;
        .left-form {
          float: left;
          width: 424px;
          min-height: 416px;
          border-radius: 4px;
          border: 1px solid #dadfe3;
          .tab {
            display: inline-block;
            padding: 20px 0;
            margin-right: 24px;
            color: #333;
            cursor: pointer;
            &.active {
              font-weight: 700;
              border-bottom: solid 2px #194ce5;
            }
            &.disabled {
              cursor: not-allowed;
            }
          }
          .s-head {
            padding: 8px 13px;
            border-bottom: solid 1px #dadfe3;
          }
          .select-form {
            width: 100%;
            height: 268px;
            border-bottom: 1px solid #dadfe3;

            overflow: auto;
            ::v-deep .el-cascader-menu {
              flex: 1;
              .el-cascader-menu__wrap {
                height: 267px;
              }
              .el-cascader-node {
                &.is-active {
                  color: inherit;
                  font-weight: normal;
                }
                &.in-active-path {
                  color: #194ce5;
                }
                .el-checkbox {
                  .el-checkbox__inner {
                    width: 16px;
                    height: 16px;
                  }
                  &.is-checked {
                    .el-checkbox__inner {
                      background-color: #333;
                      border-color: #333;
                      &::after {
                        left: 5px;
                      }
                    }
                  }
                  .is-indeterminate {
                    .el-checkbox__inner {
                      background-color: #333;
                      border-color: #333;
                    }
                  }
                }
              }
            }
          }
          .correlation-word {
            margin: 8px 0;
            padding-left: 12px;
            font-size: 12px;
          }
        }
        .right-form {
          float: left;
          margin-left: 15px;
          width: 276px;
          height: 416px;
          border-radius: 4px;
          border: 1px solid #dadfe3;
          .form-title {
            position: relative;
            padding: 8px 12px;
            .added-behavoirs {
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
              color: rgba(0, 0, 0, 0.8);
              span {
                color: #3751ff;
              }
            }
            .word-num {
              line-height: 24px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.4);
              span {
                margin-right: 20px;
              }
            }
            .clear-btn {
              position: absolute;
              top: 10px;
              right: 10px;
              color: #3547e7;
              cursor: pointer;
            }
          }
          .s-head {
            padding: 0 13px;
            line-height: 34px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.3);
            border-bottom: solid 1px #dadfe3;
            span {
              margin-right: 80px;
              &.all {
                cursor: pointer;
                &:hover {
                  color: #3547e7;
                }
              }
            }
          }
          .body {
            height: 281px;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 8px 0;
            border-bottom: 1px solid #dadfe3;
            font-size: 14px;
            .list-item {
              height: 34px;
              line-height: 34px;
              margin: 0 6px;
              padding: 0 10px;
              &:hover {
                background: #edf0fd;
                border-radius: 4px;
                .icons {
                  visibility: visible;
                }
              }
              .ellipsis {
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.name {
                  width: 110px;
                }
                &.num {
                  width: 62px;
                }
              }
              .icons {
                visibility: hidden;
                margin-left: 10px;
                vertical-align: top;
                i {
                  color: #333;
                  font-weight: bold;
                  cursor: pointer;
                  &:first-child {
                    margin-right: 10px;
                    color: #3547e7;
                  }
                }
              }
            }
            .empty {
              color: #c1c1c1;
              text-align: center;
              .img {
                margin-top: 80px;
              }
            }
          }
          .auto-select-word {
            padding-left: 11px;
            line-height: 37px;
            color: #194ce5;
            span {
              cursor: pointer;
            }
          }
        }
        .form-title {
          width: 100%;
          padding: 0 12px;
          border-bottom: 1px solid #dadfe3;
          background-color: rgba(0, 0, 0, 0.04);
          border-radius: 4px 4px 0 0;
        }
      }
    }
  }
}
</style>